module.exports = __webpack_public_path__ + "static/media/N_brand_active.7738f2db.png";